import { html } from 'lit';

const routes = [
    {
        path: '/combinedview.html',
        view: () => html`<ki-ds-pwa-combined-view></ki-ds-pwa-combined-view>`,
    },
    { path: '/multigraph.html', view: () => html`<multigraph-view></multigraph-view>` },
    { path: '/lastvalues.html', view: () => html`<last-values-view></last-values-view>` },
    { path: '/alarmstatus', view: () => html`<alarm-status-view></alarm-status-view>` },
];

export function resolveView(host) {
    const pathname = window.location.pathname;
    const route = routes.find((r) => pathname.includes(r.path));
    if (route) {
        return route.view(host);
    }
    return html`The view is not implemented`;
}
